// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"215":"8f091f9edff301a403e6","675":"2c6a143ccc5dfc72177f"}[chunkId] + ".2154.js";
};